import { type IBoundedBy } from '../types/location';

interface IBoundedByRaw {
  lowerCorner?: {
    lat?: number;
    lng?: number;
  };
  upperCorner?: {
    lat?: number;
    lng?: number;
  };
}

export function prepareBoundedBy(boundedByRaw: IBoundedByRaw): IBoundedBy {
  if (!boundedByRaw.lowerCorner || !boundedByRaw.upperCorner) {
    return { lowerCorner: { lat: 0, lng: 0 }, upperCorner: { lat: 0, lng: 0 } };
  }

  return {
    ...boundedByRaw,
    lowerCorner: {
      lat: boundedByRaw.lowerCorner?.lat || 0,
      lng: boundedByRaw.lowerCorner?.lng || 0,
    },
    upperCorner: {
      lat: boundedByRaw.upperCorner?.lat || 0,
      lng: boundedByRaw.upperCorner?.lng || 0,
    },
  };
}
